<div class="goreact-modal preview-marker-set-dialog-container">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="goreact-modal-header">
				<h4 class="modal-title" data-cy="preview-marker-set-title">
					{{ data.aiStyle ? ('modal-activity-editor-marker-set-editor_preview-ai-markers' | translate) :
						('modal-activity-editor-marker-set-editor_preview-markers' | translate)
					}}
				</h4>
				<button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
					<i class="ficon-app-x"></i>
				</button>
			</div>
			<div class="goreact-modal-body">
				<span class="marker-set-title">{{data.markerSet.title}}</span>
				<marker-display
					[markers]="data.markerSet.tags"
					[aiStyle]="data.aiStyle"
					[withName]="data.withName">
				</marker-display>
			</div>
			<div class="goreact-modal-footer">
				<button
					type="button"
					data-cy="preview-marker-close"
					class="confirm-button primary-btn"
					(click)="close()"
					translate="common_done">
				</button>
			</div>
		</div>
	</div>
</div>
